import Vue from 'vue';
import VueRouter from 'vue-router';

// views
import HomeView from '../views/HomeView';
import GenchLoadingView from '../views/GenchLoadingView';
import LogoutView from '../views/LogoutView';
import HpuLoadingView from '../views/HpuLoadingView';
import NbdhyLoadingView from '../views/NbdhyLoadingView';
import SwcvcLoadingView from '../views/SwcvcLoadingView.vue';
import GroupLoadingView from '../views/GroupLoadingView.vue'
import HnshzyLoadingView from '../views/HnshzyLoadingView.vue'
import KmyesfLoadingView from '../views/KmyesfLoadingView.vue'
import CommonLoadingView from "../views/CommonLoadingView.vue";

Vue.use(VueRouter);

// 学校接引页组件映射表
const schoolComponentMap = {
    gench: GenchLoadingView,
    hpu: HpuLoadingView,
    nbdhy: NbdhyLoadingView,
    swcvc: SwcvcLoadingView,
    hnshzy: HnshzyLoadingView,
    kmyesf: CommonLoadingView,
    ytzy: CommonLoadingView,
    ynlg: CommonLoadingView,
    yngsxy: GroupLoadingView,
    lutcte: GroupLoadingView,
    hhdu: GroupLoadingView,
    ticgx: GroupLoadingView,
    lykjxy: GroupLoadingView,
    hbmykjxy: GroupLoadingView,
    gzgszy: GroupLoadingView,
    zcu: GroupLoadingView,
};
function getComponentForSchool(school) {
    let component = schoolComponentMap[school] ;
    if (!component) {
        console.log('Unknown school:', school);
        return null;
    }
    return component;
}

// 渲染函数提取成通用组件
const schoolRouteComponent = {
    functional: true,
    render(h, { parent, data }) {
        const school = parent.$route.params.school;
        const component = getComponentForSchool(school);
        return component ? h(component, data, parent.$slots.default) : null;
    }
};

export const constantRouterMap = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/thirdauth/:school/:product/:action/:appId/:returnParam/:mttoken?',
        component: schoolRouteComponent,
    },
    {
        path: '/thirdauth/:school/:product',
        component: schoolRouteComponent,
    },
    {
        // 这里是解析从 portal-web 点击使用学校账号密码登录的url
        path: '/thirdauth/:school',
        name: 'LoadingView',
        component: schoolRouteComponent,
    },
    {
        path: '/thirdauth/:school/logout',
        component: LogoutView
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH,
    routes: constantRouterMap,
});

export default router;
